<template>
  <main>
    <div class="notfound col-md-6 m-auto d-table">
      <img src="../../../assets/img/404.gif" alt="">
      <h1>404</h1>
    </div>
    <div class="textnot ">
      <div><span>Sorry About That!</span><span class="adsaf" @click="GoBack()"><b> Return Back?</b></span></div>
    </div>
  </main>
</template>
<style lang="scss" scoped>
  @import "../../../assets/css/Error.min.css";
</style>
<script>
  export default {
    name: 'Error404',
    methods: {
      GoBack() {
        window.history.go(-1);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pages/Error/Error404.vue